import { Tag, Clock, Calendar } from 'lucide-react';
import { Button } from "@/components/ui/button";

const Offers = () => {
  return (
    <div className="animate-fade-up py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold mb-4">Special Offers</h1>
          <p className="text-xl text-gray-600">
            Discover our latest deals and promotions
          </p>
        </div>

        {/* Offers Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {[
            {
              title: "First Order Discount",
              description: "Get 20% off on your first order with us",
              code: "WELCOME20",
              validity: "Valid for new customers",
              icon: Tag
            },
            {
              title: "Lunch Special",
              description: "15% off on all orders between 12 PM to 3 PM",
              code: "LUNCH15",
              validity: "Valid on weekdays",
              icon: Clock
            },
            {
              title: "Weekend Bundle",
              description: "Free delivery on orders above $30",
              code: "WEEKEND",
              validity: "Valid on weekends",
              icon: Calendar
            },
            {
              title: "Family Pack",
              description: "Save 25% on family-size portions",
              code: "FAMILY25",
              validity: "Valid all days",
              icon: Tag
            },
            {
              title: "Early Bird",
              description: "10% off on breakfast orders before 10 AM",
              code: "EARLY10",
              validity: "Valid daily",
              icon: Clock
            },
            {
              title: "Monthly Special",
              description: "30% off on selected items",
              code: "MONTHLY30",
              validity: "Valid this month",
              icon: Calendar
            }
          ].map((offer, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow"
            >
              <div className="bg-primary/10 p-6">
                <offer.icon className="h-12 w-12 text-primary mb-4" />
                <h3 className="text-xl font-semibold mb-2">{offer.title}</h3>
                <p className="text-gray-600 mb-4">{offer.description}</p>
              </div>
              <div className="p-6 bg-white">
                <div className="mb-4">
                  <p className="text-sm text-gray-500 mb-1">Promo Code:</p>
                  <p className="font-mono font-bold text-primary">{offer.code}</p>
                </div>
                <p className="text-sm text-gray-500 mb-4">{offer.validity}</p>
                <Button className="w-full bg-primary hover:bg-primary/90">
                  Claim Offer
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Offers;